<template>
<div class="chapter">
<div class="inner_page">
<p class="dedit"><span class="bold">Dedication</span></p>
<p class="dedi">For my father, John Hopkins</p>
<p class="dedi">who always had his head in a book</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?77544361